import { createActions } from '../utils/actions';

const { actions: selectMedia } = createActions('selectMedia')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getFolders')
  .addAsync('getItems')
  .add('setValue')
  .add('toggleItemState');

export default selectMedia;
